import React, { useState, useEffect } from "react";
import axios from "../Axiosinstance";
import { Modal, Form, ButtonGroup, Row, Col } from "react-bootstrap";
import { FaMinus, FaPlus } from "react-icons/fa";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { baseURLdyte, Password, Username } from "../common";
import Button from '@mui/material/Button';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const BatchForm = ({ onFormSubmit }) => {
  const [selectedTrainers, setSelectedTrainers] = useState([]);
  const [selectedAssessors, setSelectedAssessors] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [facilitatorData, setFacilitatorData] = useState(null);

  const [searchText, setSearchText] = useState("");
  const [itemsPerPage, setItemsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);

  const initialFieldErrors = {
    course: "",
    courseId: "",
    batchCode: "",
    online: "",
    attendance: "",
    status: "",
    intakeSize: "",
    threshold: "",
    venue: "",


  };

  useEffect(() => {
    axios
      .get("categorys")
      .then((response) => setCategory(response.data))
      .catch((error) => console.error("Error fetching course data:", error));
  }, []);

  // useEffect(() => {
  //   axios
  //     .get("venues")
  //     .then((response) => setVenues(response.data))
  //     .catch((error) => console.error("Error fetching venue data:", error));
  // }, []);

  const handleCloseModal = () => {
    setShowModal(false);
  };

  // const handleSelectTrainer = (trainer) => {
  //   setSelectedTrainers((prevTrainers) => [...prevTrainers, trainer]);
  // };

const handleSelectTrainer = (trainer) => {
  setSelectedTrainers((prevTrainers) => {

    const alreadyExists = prevTrainers.includes(trainer);

    if (alreadyExists) {
      toast.error("Trainer already assigned to this batch!");
      return prevTrainers;
    }

    return [...prevTrainers, trainer];
  });
};

  // const handleSelectAssessor = (assessor) => {
  //   setSelectedAssessors((prevAssessors) => [...prevAssessors, assessor]);
  // };
  
const handleSelectAssessor = (assessor) => {
  setSelectedAssessors((prevAssessors) => {

    const alreadyExists = prevAssessors.includes(assessor);

    if (alreadyExists) {
      toast.error("Assessor already assigned!");
      return prevAssessors;
    }

    return [...prevAssessors, assessor];
  });
};

  const handleDeleteTrainer = (trainer) => {
    setSelectedTrainers((prevTrainers) =>
      prevTrainers.filter((t) => t !== trainer)
    );
  };

  const handleDeleteAssessor = (assessor) => {
    setSelectedAssessors((prevAssessors) =>
      prevAssessors.filter((a) => a !== assessor)
    );
  };

  // Function to fetch facilitator details from the API
  const fetchFacilitatorDetails = () => {
    axios
      .get("facilitators")
      .then((response) => setFacilitatorData(response.data))
      .catch((error) =>
        console.error("Error fetching facilitator data:", error)
      );
  };

  useEffect(() => {
    fetchFacilitatorDetails();
  }, []);

  useEffect(() => {
    fetchFacilitatorDetails();
  }, []);

  const handleAddTrainer = (e) => {
    e.preventDefault();
    fetchFacilitatorDetails();
    setShowModal(true);
  };

  const handleAddAssessor = (e) => {
    e.preventDefault();
    fetchFacilitatorDetails();
    setShowModal(true);
  };

  const [formModified, setFormModified] = useState(false);

  useEffect(() => {
    const handleFormModification = () => {
      if (!formModified) {
        setFormModified(true);
      }
    };

    window.addEventListener("input", handleFormModification);

    return () => {
      window.removeEventListener("input", handleFormModification);
    };
  }, [formModified]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (formModified) {
        event.returnValue =
          "You have unsaved changes. Are you sure you want to leave this page?";
      }
    };

    window.onbeforeunload = handleBeforeUnload;

    return () => {
      window.onbeforeunload = null;
    };
  }, [formModified]);

  const [category, setCategory] = useState([]);
  const [venues, setVenues] = useState([]);
  const [courseImage, setCourseImage] = useState("");
  const [batchData, setBatchData] = useState({
    course: "",
    // name:"",
    registrationFee: null,
    courseFee: null,
    category: "",
    type: "",
    batchcode: "",
    onlineclasslink: "",
    attendanceqrlink: "",
    esignrequired: "",
    threshold: null,
    intakesize: null,
    venue: "",
    currentModule: 0,
    startDate: "",
    courseId: "",
    courseType: "",
    courseImage: "",
    duration: "",
    description: "",
    weekPerModule: "",
    project: false,
    moduleDetails: [
      { id: 1, moduleName: "" }
    ],
    trainers: facilitatorData,
    assessors: facilitatorData,
    category: { id: '' },
    days: [
      {
        id: "",
        day: "",
        sessionIndex: 0,
        sessions: {},
        startTime: "",
        endTime: "",
      },
    ],
    assignment: false,
  });


  const handleInputChange1 = (dayIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    newDays[dayIndex] = { ...newDays[dayIndex], [fieldName]: value };
    setBatchData({ ...batchData, days: newDays });
  };

  const getDisabledDays = (dayIndex) => {
    const selectedDays = batchData.days
      .slice(0, dayIndex)
      .map((day) => day.day); // Get days selected in previous rows
    const dayOrder = [
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
      "Sunday",
    ];


    const maxSelectedIndex = Math.max(
      ...selectedDays.map((day) => dayOrder.indexOf(day)),
      -1 // Default value if no days are selected
    );

    // Disable days that come before or equal to the max selected index
    return dayOrder.reduce((disabledMap, day, index) => {
      disabledMap[day] = index <= maxSelectedIndex;
      return disabledMap;
    }, {});
  };




  const handleAddRow = () => {
    setBatchData((prevData) => ({
      ...prevData,
      days: [
        ...prevData.days,
        {
          id: "",
          day: "",
          sessionIndex: prevData.days.length,
          sessions: {},
          startTime: "",
          endTime: "",
        },
      ],
    }));
  };


  const handleRemoveRow = (dayIndex) => {
    if (batchData.days.length > 1) {
      const newDays = batchData.days.filter((_, index) => index !== dayIndex);
      setBatchData((prevData) => ({
        ...prevData,
        days: newDays,
      }));
    }
  };



  const handleSessionChange = (dayIndex, sessionIndex, fieldName, event) => {
    const { value } = event.target;
    const newDays = [...batchData.days];
    const sessions = { ...newDays[dayIndex].sessions };
    const sessionKey = `Session ${sessionIndex + 1}`;

    sessions[sessionKey] = {
      ...sessions[sessionKey],
      [fieldName]: value,
    };

    newDays[dayIndex] = { ...newDays[dayIndex], sessions };
    setBatchData({ ...batchData, days: newDays });
  };

  const handleAddSession = (dayIndex) => {
    const newDays = [...batchData.days];
    const currentSessions = newDays[dayIndex].sessions;
    const newSessionNumber = Object.keys(currentSessions).length + 1; // Adjust if needed

    newDays[dayIndex].sessions = {
      ...currentSessions,
      [`Session ${newSessionNumber}`]: {
        startTime: "",
        endTime: "",
      },
    };

    setBatchData({ ...batchData, days: newDays });
  };

  const handleRemoveSession = (dayIndex, sessionIndex) => {
    const newDays = [...batchData.days];
    const newSessions = { ...newDays[dayIndex].sessions };

    // Delete the session that needs to be removed
    const sessionKeys = Object.keys(newSessions);
    sessionKeys.splice(sessionIndex, 1); // Remove the session key from the array

    // Rebuild the sessions object with updated keys
    const updatedSessions = {};
    sessionKeys.forEach((key, index) => {
      updatedSessions[`Session ${index + 1}`] = newSessions[key];
    });

    // Update the state with new sessions
    newDays[dayIndex] = { ...newDays[dayIndex], sessions: updatedSessions };
    setBatchData({ ...batchData, days: newDays });
  };

  const CLOUDINARY_URL = "https://api.cloudinary.com/v1_1/dyjwwi8ea/raw/upload";
  const CLOUDINARY_UPLOAD_PRESET = "vldqgwk8";

  const handleImageUpload = async (e) => {
    try {
      const file = e.target.files[0];
      if (!file) {
        return;
      }

      const formData = new FormData();
      formData.append("file", file);
      formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
      formData.append("public_id", "LMS/courses/" + file.name);

      const response = await fetch(CLOUDINARY_URL, {
        method: "POST",
        body: formData,
      });

      const data = await response.json();

      if (data.secure_url) {
        setCourseImage(data.secure_url);
        setBatchData((prevData) => ({
          ...prevData,
          courseImage: data.secure_url,
        }));
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    // Update both 'batchcode' and 'course' if 'batchcode' is changed
    if (name === "batchcode") {
      setBatchData((prevData) => ({
        ...prevData,
        batchcode: value,
        course: value, // Keep 'course' in sync with 'batchcode'
      }));
    } else if (name === "duration") {
      const numericValue = parseInt(value, 10);
      if (numericValue < 1 || numericValue > 100) return;
      setBatchData(prev => ({ ...prev, [name]: numericValue }));
    } else if (name === "course") {
      setBatchData((prevData) => ({
        ...prevData,
        course: value,
        batchcode: value, // Keep 'batchcode' in sync with 'course'
      }));
      // } else if (name === 'categoryId') {
      //   setBatchData((prevData) => ({
      //     ...prevData,
      //     category: {
      //       id: value,
      //     },
      //   }));
    } else if (type === "checkbox") {
      setBatchData((prevState) => ({
        ...prevState,
        [name]: checked,
      }));
    } else {
      setBatchData((prevData) => ({ ...prevData, [name]: value }));
    }
  };


  // useEffect(() => {
  //   const fetchData = async () => {
  //     try {

  //       const venuesResponse = await axios.get('venues');
  //       // setVenues([{ id: 'Online/Classroom', roomno: 'Online/Classroom' }, ...venuesResponse.data]);
  //       // const categoriesResponse = await axios.get('categorys');
  //       // setCategories(categoriesResponse.data);
  //       fetchFacilitatorDetails();
  //     } catch (error) {
  //       console.error('Error fetching data:', error);
  //     }
  //   };
  //   fetchData();
  // }, []);

  const handleModuleChange = (e, id) => {
    const { name, value } = e.target;
    const updatedModuleDetails = batchData.moduleDetails.map((module) =>
      module.id === id ? { ...module, [name]: value } : module
    );
    setBatchData({ ...batchData, moduleDetails: updatedModuleDetails });
  };

  const handleModuleSelect = (id) => {
    setBatchData({ ...batchData, currentModule: id });
  };

  const handleAddModule = () => {
    const newId = batchData.moduleDetails.length
      ? Math.max(...batchData.moduleDetails.map((m) => m.id)) + 1
      : 1;
    const newModule = { id: newId, moduleName: "" };
    setBatchData({
      ...batchData,
      moduleDetails: [...batchData.moduleDetails, newModule],
    });
  };

  const handleRemoveModule = (id) => {
    const updatedModules = batchData.moduleDetails.filter((m) => m.id !== id);
    const updatedCurrent =
      batchData.currentModule === id ? null : batchData.currentModule;
    setBatchData({
      ...batchData,
      moduleDetails: updatedModules,
      currentModule: updatedCurrent,
    });
  };



  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const trainerNames = selectedTrainers.map((trainer) => trainer);
  const assessorNames = selectedAssessors.map((assessor) => assessor);
  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (selectedTrainers.length === 0) {
        toast.error('Please add at least one facilitator before submitting!');
        return; // Prevent form submission
      }
      setShowConfirmationModal(true);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleConfirmSubmit = async () => {

    const formattedDays = batchData.days.map((day) => ({
      day: day.day,
      sessions: Object.keys(day.sessions).reduce((acc, key) => {
        acc[key] = day.sessions[key];
        return acc;
      }, {}),
    }));
    // Update batchData with facilitator names
    const updatedBatchData = {
      ...batchData,
      trainers: trainerNames,
      assessors: assessorNames,
      days: formattedDays,
    };

    try {
      const response = await axios.post("batch", updatedBatchData);

      if (response.status === 200) {
        console.log("Batch data submitted successfully!");
        onFormSubmit();
      } else {
        console.error("Failed to submit batch data.");
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setShowConfirmationModal(false);
    }
  };

  const handleCancelSubmit = () => {
    setShowConfirmationModal(false);
  };

  const [showCancelConfirmationModal, setShowCancelConfirmationModal] =
    useState(false);

  const handleCancel = () => {
    setShowCancelConfirmationModal(true);
  };

  const handleConfirmCancel = () => {
    onFormSubmit();
    // Additional cancel logic if needed
    setShowCancelConfirmationModal(false);
  };

  const handleCancelCancel = () => {
    setShowCancelConfirmationModal(false);
  };

  const containerStyle = {
    backgroundColor: "white",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.1)",
    padding: "20px",
    maxWidth: "800px",
    margin: "auto",
    marginTop: "20px",
  };

  const handleCheckboxChange = (e) => {
    const value = e.target.checked ? "yes" : "no";
    setBatchData({ ...batchData, esignrequired: value });
  };

  const [showConfirmation, setShowConfirmation] = useState(false);
  const [dayIndexToDelete, setDayIndexToDelete] = useState(null);

  const handleRemoveDay = (dayIndex) => {
    setDayIndexToDelete(dayIndex);
    setShowConfirmation(true);
  };

  const confirmRemoveDay = () => {
    // Delete the day when the user confirms
    setBatchData((prevData) => {
      const updatedDays = [...prevData.days];
      updatedDays.splice(dayIndexToDelete, 1);
      return { ...prevData, days: updatedDays };
    });

    // Close the confirmation modal
    setShowConfirmation(false);
    toast.success("Day removed successfully!", {
      position: "bottom-right",
    });
  };

  const closeConfirmation = () => {
    // Close the confirmation modal without deleting the day
    setShowConfirmation(false);
  };

  const [meetingDetails, setMeetingDetails] = useState({});
  const [meetingLink, setMeetingLink] = useState("");
  const username = Username;
  const password = Password;
  const baseURL = baseURLdyte;
  const [showMeetingModal, setShowMeetingModal] = useState(false);
  const [meetingTitle, setMeetingTitle] = useState("");

  const handleShowMeetingModal = () => {
    setShowMeetingModal(true);
  };

  const handleCloseMeetingModal = () => {
    setShowMeetingModal(false);
  };

  const handleMeetingTitleChange = (e) => {
    setMeetingTitle(e.target.value);
  };

  const handleCreateMeeting = async () => {
    try {
      const response = await axios.post(
        `${baseURL}/meetings`,
        {
          title: meetingTitle,
          preferred_region: "ap-south-1",
          record_on_start: false,
          live_stream_on_start: false,
          recording_config: {
            max_seconds: 7200,
            file_name_prefix: "string",
            video_config: {
              codec: "H264",
              width: 1280,
              height: 720,
              watermark: {
                url: "https://i.ibb.co/PtV93qZ/logo.jpg",
                size: { width: 2, height: 2 },
                position: "left top",
              },
            },
            audio_config: { codec: "AAC", channel: "stereo" },
            storage_config: {
              type: "aws",
              access_key: "string",
              secret: "string",
              bucket: "string",
              region: "us-east-1",
              path: "string",
              auth_method: "KEY",
              username: "string",
              password: "string",
              host: "string",
              port: 0,
              private_key: "string",
            },
            dyte_bucket_config: { enabled: true },

          },
        },
        {
          auth: {
            username: username,
            password: password,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      if (response && response.data) {
        // Extract the meeting ID from the response
        const meetingId = response.data.data.id;
        // Omit participant addition in this part of the code
        // Construct the complete meeting link using base link, id, and authToken
        const completeMeetingLink = `${baseURL}/meeting?id=${meetingId}`;
        // Update batchData with the meeting link
        setBatchData((prevData) => ({
          ...prevData,
          onlineclasslink: completeMeetingLink,
        }));
        // Close the meeting modal
        handleCloseMeetingModal();
      } else {
        console.error("Invalid response from Dyte API");
      }
    } catch (error) {
      console.error("Error creating meeting:", error);
    }
  };

  const isValidDate = (dateString) => {
    const selectedDate = new Date(dateString);
    const minDate = new Date(
      new Date().setFullYear(new Date().getFullYear() - 2)
    );
    const maxDate = new Date(
      new Date().setFullYear(new Date().getFullYear() + 2)
    );
    return selectedDate >= minDate && selectedDate <= maxDate;
  };

  return (
    <div className="batch-form-container">
      <Modal show={showConfirmationModal} onHide={handleCancelSubmit} centered>
        <Modal.Header closeButton>
          <Modal.Title>Save Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to save this batch?</Modal.Body>
        <Modal.Footer>
          <Button style={{ backgroundColor: '#007bff', color: "white", marginRight: '5px' }} onClick={handleCancelSubmit}>
            Cancel
          </Button>
          <Button style={{ backgroundColor: '#007bff', color: "white" }} onClick={handleConfirmSubmit}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <form onSubmit={handleSubmit} className="row" style={containerStyle}>
        <h2>New Course (Allians International College)</h2>
        <br />
        <br />
        <br />
        <div style={{ marginBottom: "15px" }}>
          {/* Row 1: Name and Category */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginBottom: "15px",
            }}
          >
            <div style={{ flex: "1", marginRight: "10px" }}>
              <label htmlFor="name">Course Name:</label>
              <input
                type="text"
                id="batchCode"
                className="form-control"
                name="batchcode"
                style={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                value={batchData.batchcode}
                onChange={handleInputChange}
                placeholder="Course Name"
                required
              />
            </div>




            <div style={{ flex: "1" }}>
              <label htmlFor="type">Category</label>
              <select
                id="category"
                name="categoryId"
                value={batchData.category?.id || ""}
                style={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                onChange={(e) => {
                  const selectedCategory = category.find(
                    (cat) => cat.id === parseInt(e.target.value, 10)
                  );
                  setBatchData((prevData) => ({
                    ...prevData,
                    category: {
                      id: selectedCategory?.id || "",
                      name: selectedCategory?.name || "",
                    },
                  }));
                }}
              >
                <option value="">Select Category</option>
                {category.map((category) => (
                  <option key={category.id} value={category.id}>
                    {category.name}
                  </option>
                ))}
              </select>
            </div>

          </div>

          {/* Row 2: Registration Fee and Course Fee */}
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ flex: "1", marginRight: "10px" }}>
              <label htmlFor="registrationFee">Registration Fee:</label>
              <input
                type="text"
                id="registrationFee"
                className="form-control"
                name="registrationFee"
                style={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                value={batchData.registrationFee}
                onChange={handleInputChange}
                placeholder="Registration Fee"
                required
              />
            </div>
            <div style={{ flex: "1" }}>
              <label htmlFor="courseFee">Course Fee:</label>
              <input
                type="text"
                id="courseFee"
                className="form-control"
                name="courseFee"
                style={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                value={batchData.courseFee}
                onChange={handleInputChange}
                placeholder="Course Fee"
                required
              />
            </div>
          </div>
        </div>

        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div style={{ flex: "1", marginRight: "10px" }}>
            <label htmlFor="fileupload">Course Image:</label>
            <input
              type="file"
              id="fileupload"
              className="form-control"
              name="courseImage"
              // onChange={handleImageUpload}
              onChange={(event) => {
                const file = event.target.files[0];
                if (file && file.size > 8 * 1024 * 1024) {
                  event.target.value = ""; // Reset file input
                  alert("File size must be less than 8MB.");
                } else {
                  handleImageUpload(event);
                }
              }}
              accept="image/*"
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              required
            />
          </div>

          <div style={{ flex: "1" }}>
            <label>Venue:</label>
            <select
              name="venue"
              className="form-control"
              value={batchData.venue}
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              onChange={handleInputChange}
              required
            >
              <option value="" disabled>
                Select a venue
              </option>
              <option value="Online/Classroom" style={{
                height: "60px", // Increase the height of this option
                padding: "10px", // Add padding inside the option
              }}>
                Online/Classroom
              </option>

              {/* {venues.map((venue) => (
                <option key={venue.id} value={venue.roomno}>
                  {venue.roomno}
                </option>
              ))} */}
            </select>
          </div>
        </div>




        {/* <div style={{ flex: "1", marginRight: "10px" }}>
            <label htmlFor="type">Course Type</label>
            <select
              id="type"
              className="form-control"
              name="type"
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              value={batchData.type}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Type</option>
              <option value="diploma">Diploma</option>
              <option value="advance_diploma">Advanced Diploma</option>
            </select>
          </div> */}

        <div style={{ display: "flex", gap: "16px", alignItems: "center" }}>
          {/* Course Type */}
          <div style={{ flex: "1" }}>
            <label htmlFor="courseType">Type:</label>
            <select
              id="courseType"
              className="form-control"
              name="courseType"
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              value={batchData.courseType}
              onChange={handleInputChange}
              required
            >
              <option value="">Select Course Type</option>
              <option value="Part time">Part Time</option>
              <option value="Full time">Full Time</option>
            </select>
          </div>

          {/* Week per Module */}
          <div style={{ flex: "1" }}>
            <label htmlFor="weekPerModule">Week per Module:</label>
            <input
              type="number"
              id="weekPerModule"
              className="form-control"
              name="weekPerModule"
              style={{
                width: "100%",
                height: "46px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              value={batchData.weekPerModule}
              onChange={handleInputChange}
              placeholder="Week per Module"
              required
            />
          </div>

          {/* Project Checkbox */}
          <div style={{ flex: "1", display: "flex", flexDirection: "column" }}>
            <label htmlFor="project" style={{ marginBottom: "8px" }}>Project:</label>
            <input
              type="checkbox"
              id="project"
              name="project"
              checked={batchData.project === true}
              onChange={(e) =>
                handleInputChange({
                  target: {
                    name: "project",
                    value: e.target.checked,
                  },
                })
              }
              style={{
                width: "20px",
                height: "20px",
              }}
            />
          </div>
        </div>




        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "15px",
          }}
        >
          <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
            {/* Online Class Link */}
            <div style={{ flex: "1 1 ", minWidth: "250px" }}>
              <label>Online Class Link:</label>
              <div style={{ display: "flex" }}>
                <input
                  type="text"
                  className="form-control"
                  name="onlineclasslink"
                  value={batchData.onlineclasslink}
                  onChange={handleInputChange}
                  placeholder="Enter online class link"
                  style={{
                    flex: 1,
                    height: "42px",
                    borderRadius: "8px 0 0 8px",
                    border: "1px solid #ced4da",
                  }}
                  required
                />
                <button
                  type="button"
                  onClick={handleShowMeetingModal}
                  style={{
                    background: "dodgerblue",
                    color: "white",
                    border: "none",
                    borderRadius: "0 8px 8px 0",
                    padding: "0 12px",
                    cursor: "pointer",
                  }}
                >
                  +
                </button>
              </div>
            </div>

            {/* Duration */}
            <div style={{ flex: "1 1", minWidth: "180px" }}>
              <label htmlFor="duration">Duration (Month):</label>
              <input
                type="number"
                id="duration"
                className="form-control"
                name="duration"
                style={{
                  width: "100%",
                  height: "42px",
                  borderRadius: "6px",
                  border: "1px solid #ced4da",
                }}
                value={Number(batchData.duration) || ""}
                onChange={handleInputChange}
                placeholder="Course duration"
                required
                max={100}
                min={1}
              />
            </div>

            {/* Description */}
            <div style={{ flex: "1 1 100%", minWidth: "250px" }}>
              <label htmlFor="description">Description:</label>
              <div style={{ border: "1px solid #ced4da", borderRadius: "6px", minHeight: "150px" }}>
                <ReactQuill
                  id="description"
                  name="description"
                  value={batchData.description}
                  onChange={(content) =>
                    handleInputChange({ target: { name: "description", value: content } })
                  }
                  placeholder="Enter course description"
                  style={{ height: "100%", width: "100%" }}
                />
              </div>
            </div>
          </div>

          {/* Intake Size */}
          {/* <div style={{ flex: "1" }}>
            <label>Intake Size:</label>
            <input
              type="number"
              pattern="[0-9]*"
              className="form-control"
              name="intakesize"
              style={{
                width: "100%",
                height: "42px",
                borderRadius: "6px",
                border: "1px solid #ced4da",
              }}
              value={batchData.intakesize}
              maxLength={3}
              onChange={(e) => {
                const inputNumber = e.target.value.slice(0, 3); // Restrict input to first 3 characters
                setBatchData((prevState) => ({
                  ...prevState,
                  intakesize:
                    inputNumber === "" ? 0 : parseInt(inputNumber, 10),
                }));
              }}
              title="3 Numbers Only"
              required
            />
          </div> */}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            marginBottom: "15px",
          }}
        >
          <h3>Module Details</h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)", // Two modules per row
              gap: "20px", // Space between the module cards
            }}
          >
            {batchData.moduleDetails.map((module, index) => (
              <div
                key={module.id}
                className="form-group"
                style={{
                  border: "1px solid #ced4da",
                  borderRadius: "6px",
                  padding: "10px",
                  marginBottom: "10px",
                  background: "#f8f9fa",
                }}
              >
                <div style={{ display: "flex", alignItems: "center" }}>
                  <input
                    type="radio"
                    id={`moduleSelect${module.id}`}
                    name="currentModule"
                    value={module.id}
                    checked={batchData.currentModule === module.id}
                    onChange={() => handleModuleSelect(module.id)}
                    style={{ marginRight: "10px" }}
                    required
                  />
                  <label
                    htmlFor={`moduleName${module.id}`}
                    style={{ fontWeight: "bold", marginRight: "10px" }}
                  >
                    Module {index + 1}:
                  </label>
                  {batchData.moduleDetails.length > 1 && (
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleRemoveModule(module.id)}
                      style={{ marginLeft: "auto" }}
                    >
                      Remove
                    </Button>
                  )}
                </div>
                <input
                  type="text"
                  id={`moduleName${module.id}`}
                  name="moduleName"
                  className="form-control"
                  style={{
                    width: "100%",
                    height: "42px",
                    borderRadius: "6px",
                    border: "1px solid #ced4da",
                    marginTop: "8px",
                  }}
                  value={module.moduleName}
                  onChange={(e) => handleModuleChange(e, module.id)}
                  placeholder={`Enter Module ${index + 1} name`}
                  required
                />
              </div>
            ))}


          </div>
          <Button
            variant="contained"
            onClick={handleAddModule}
            style={{ marginTop: "10px" }}
          >
            Add Module
          </Button>

          <Modal show={showMeetingModal} onHide={handleCloseMeetingModal}>
            <Modal.Header closeButton>
              <Modal.Title>Enter Meeting Title</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Form.Control
                type="text"
                placeholder="Enter meeting title"
                value={meetingTitle}
                onChange={handleMeetingTitleChange}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button variant="outlined"
                color="secondary"
                sx={{ marginRight: 2 }} onClick={handleCloseMeetingModal}>
                Cancel
              </Button>
              <Button variant="contained"
                color="primary" onClick={handleCreateMeeting}>
                Create
              </Button>
            </Modal.Footer>
          </Modal>

          <br />
          <button
            variant="btn-primary "
            onClick={handleAddTrainer}
            style={{
              backgroundColor: "#1E90FF",
              color: "white",
              border: "none",
              padding: "10px 20px",
              borderRadius: "7px",
              fontSize: "13px",
            }}
          >
            <FaPlus /> Add Trainer
          </button>
        </div>

        <div>
          <div>
            <Modal
              show={showModal}
              onHide={handleCloseModal}
              size="lg"
              centered
            >
              <Modal.Header closeButton>
                <Modal.Title>Trainer/Assessor Details</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row align-items-center">
                  <div className="col-md-4">
                    <div className="input-group mb-3">
                      <span
                        className="input-group-text"
                        style={{ height: "45px" }}
                      >
                        Search
                      </span>
                      <input
                        type="text"
                        id="search"
                        className="form-control"
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        style={{ height: "45px" }}
                      />
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="input-group mb-3">
                      <span className="input-group-text">Show</span>
                      <select
                        id="itemsPerPage"
                        className="form-control"
                        value={itemsPerPage}
                        onChange={(e) =>
                          setItemsPerPage(Number(e.target.value))
                        }
                        style={{ height: "45px" }}
                      >
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={25}>25</option>
                      </select>
                    </div>
                  </div>
                </div>

                {facilitatorData && facilitatorData.length > 0 ? (
                  <>
                    <div className="table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th style={{ fontWeight: 'bold' }} >Name</th>
                            <th style={{ fontWeight: 'bold' }} >Email</th>
                            <th style={{ fontWeight: 'bold' }} >NRIC</th>
                            <th style={{ fontWeight: 'bold' }} >Add Trainer</th>
                            <th style={{ fontWeight: 'bold' }} >Add Assessor</th>
                          </tr>
                        </thead>
                        <tbody>
                          {facilitatorData
                            .filter(
                              (facilitator) =>
                                facilitator.name
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase()) ||
                                facilitator.email
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase()) ||
                                facilitator.nric
                                  .toLowerCase()
                                  .includes(searchText.toLowerCase())
                            )
                            .slice(
                              (currentPage - 1) * itemsPerPage,
                              currentPage * itemsPerPage
                            )
                            .map((facilitator) => {
                              const isTrainerSelected =
                                selectedTrainers.includes(
                                  facilitator.name + "(" + facilitator.id + ")"
                                );
                              const isAssessorSelected =
                                selectedAssessors.includes(
                                  facilitator.name + "(" + facilitator.id + ")"
                                );

                              // Determine if the Add buttons should be disabled
                              // const disableAddTrainer =
                              //   selectedTrainers.length >= 1 ||
                              //   isTrainerSelected;
                              const disableAddTrainer = isTrainerSelected;
                              // const disableAddAssessor =
                              //   selectedAssessors.length >= 1 ||
                              //   isAssessorSelected;
                              const disableAddAssessor = isAssessorSelected;

                              return (
                                <tr key={facilitator.id}>
                                  <td>{facilitator.name}</td>
                                  <td>{facilitator.email}</td>
                                  <td>{facilitator.nric}</td>
                                  <td>
                                    <button
                                      className="primary"
                                      type="button"
                                      onClick={() =>
                                        handleSelectTrainer(
                                          facilitator.name +
                                          "(" +
                                          facilitator.id +
                                          ")"
                                        )
                                      }
                                      disabled={disableAddTrainer}
                                      style={{
                                        backgroundColor: disableAddTrainer
                                          ? "#d3d3d3"
                                          : "#1E90FF",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        borderRadius: "7px",
                                      }}
                                    >
                                      <FaPlus /> Add
                                    </button>
                                  </td>
                                  <td>
                                    <button
                                      className="primary"
                                      onClick={() =>
                                        handleSelectAssessor(
                                          facilitator.name +
                                          "(" +
                                          facilitator.id +
                                          ")"
                                        )
                                      }
                                      disabled={disableAddAssessor}
                                      style={{
                                        backgroundColor: disableAddAssessor
                                          ? "#d3d3d3"
                                          : "#1E90FF",
                                        color: "white",
                                        border: "none",
                                        padding: "10px 20px",
                                        borderRadius: "7px",
                                      }}
                                    >
                                      <FaPlus /> Add
                                    </button>
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "end",
                        float: "inline-end",
                      }}
                    >
                      <div
                        className="pagination"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <button
                          className="btn btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prevPage) =>
                              Math.max(prevPage - 1, 1)
                            )
                          }
                          disabled={currentPage === 1}
                          style={{ width: "100px", marginRight: "10px" }}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </button>
                        <span className="mx-2">Page {currentPage}</span>
                        <button
                          className="btn btn-outline-primary"
                          onClick={() =>
                            setCurrentPage((prevPage) =>
                              Math.min(
                                prevPage + 1,
                                Math.ceil(facilitatorData.length / itemsPerPage)
                              )
                            )
                          }
                          disabled={
                            currentPage ===
                            Math.ceil(facilitatorData.length / itemsPerPage)
                          }
                          style={{ width: "100px" }}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </button>
                      </div>
                    </div>
                  </>
                ) : (
                  <p>No facilitator data found.</p>
                )}
              </Modal.Body>
            </Modal>

            <div>
              {selectedTrainers.length > 0 && (
                <div>
                  <h3>Selected Trainers:</h3>
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {selectedTrainers.map((trainer, index) => {
                      // Use regular expression to extract the trainer name
                      const trainerName = trainer.match(/^[^\d()]*/)[0].trim();
                      return (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "10px 0",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                          }}
                        >
                          <div>
                            {index + 1}. {trainerName}
                          </div>
                          <button
                            className="primary"
                            onClick={() => handleDeleteTrainer(trainer)}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              padding: "10px 20px",
                              borderRadius: "7px",
                            }}
                          >
                            Remove
                          </button>
                        </li>
                      );
                    })}
                  </ul>

                  {/* <p>
        Total Selected Trainers: {selectedTrainers.length}
      </p> */}
                </div>
              )}
            </div>

            <div>
              {selectedAssessors.length > 0 && (
                <div>
                  <h3>Selected Assessors:</h3>
                  <ul style={{ listStyleType: "none", padding: 0 }}>
                    {selectedAssessors.map((assessor, index) => {
                      // Use regular expression to extract the assessor name
                      const assessorName = assessor
                        .match(/^[^\d()]*/)[0]
                        .trim();

                      return (
                        <li
                          key={index}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            margin: "10px 0",
                            padding: "10px",
                            border: "1px solid #ccc",
                            borderRadius: "5px",
                          }}
                        >
                          <div>
                            {index + 1}. {assessorName}
                          </div>
                          <button
                            className="primary"
                            onClick={() => handleDeleteAssessor(assessor)}
                            style={{
                              backgroundColor: "red",
                              color: "white",
                              border: "none",
                              padding: "10px 20px",
                              borderRadius: "7px",
                            }}
                          >
                            Remove
                          </button>
                        </li>
                      );
                    })}
                  </ul>
                  <p>
                    Total Selected Facilitators:{" "}
                    {selectedTrainers.length + selectedAssessors.length}
                  </p>
                  {/* <p>
        Total Selected Assessors: {selectedAssessors.length}
      </p> */}
                </div>
              )}
            </div>
          </div>
        </div>
        <div>
          <h3 style={{ marginBottom: "20px" }}>Schedule Management</h3>
          {batchData.days.map((day, dayIndex) => (
            <div
              key={dayIndex}
              style={{
                border: "1px solid #ced4da",
                borderRadius: "8px",
                padding: "20px",
                marginBottom: "20px",
                background: "#f8f9fa",
              }}
            >
              <Row className="mb-3">
                <Col md={3}>
                  <label htmlFor={`day-${dayIndex}`} style={{ fontWeight: "bold" }}>
                    Select Day:
                  </label>
                  <select
                    id={`day-${dayIndex}`}
                    className="form-control"
                    name="day"
                    value={day.day}
                    onChange={(event) =>
                      handleInputChange1(dayIndex, "day", event)
                    }
                    required
                    style={{
                      borderRadius: "6px",
                      padding: "8px",
                    }}
                  >
                    <option value="" disabled>
                      Select a day
                    </option>
                    {[
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                      "Sunday",
                    ].map((dayName) => {
                      const disabledDays = getDisabledDays(dayIndex);
                      return (
                        <option key={dayName} value={dayName} disabled={disabledDays[dayName]}>
                          {dayName}
                        </option>
                      );
                    })}
                  </select>
                </Col>
              </Row>

              <div style={{ marginBottom: "10px" }}>
                {Object.keys(day.sessions).map((sessionKey, sessionIndex) => (
                  <Row key={sessionKey} className="align-items-end mb-3">
                    <Col md={3}>
                      <label
                        htmlFor={`session-${dayIndex}-${sessionIndex}`}
                        style={{ fontWeight: "bold" }}
                      >
                        Session:
                      </label>
                      <input
                        type="text"
                        id={`session-${dayIndex}-${sessionIndex}`}
                        className="form-control"
                        name="session"
                        value={sessionKey}
                        readOnly
                        style={{
                          borderRadius: "6px",
                          padding: "8px",
                          background: "#e9ecef",
                          fontWeight: "500",
                        }}
                      />
                    </Col>

                    <Col md={3}>
                      <label
                        htmlFor={`startTime-${dayIndex}-${sessionIndex}`}
                        style={{ fontWeight: "bold" }}
                      >
                        Start Time:
                      </label>
                      <input
                        type="time"
                        id={`startTime-${dayIndex}-${sessionIndex}`}
                        className="form-control"
                        name="startTime"
                        value={day.sessions[sessionKey].startTime}
                        onChange={(event) =>
                          handleSessionChange(
                            dayIndex,
                            sessionIndex,
                            "startTime",
                            event
                          )
                        }
                        required
                        style={{
                          borderRadius: "6px",
                          padding: "8px",
                        }}
                      />
                    </Col>

                    <Col md={3}>
                      <label
                        htmlFor={`endTime-${dayIndex}-${sessionIndex}`}
                        style={{ fontWeight: "bold" }}
                      >
                        End Time:
                      </label>
                      <input
                        type="time"
                        id={`endTime-${dayIndex}-${sessionIndex}`}
                        className="form-control"
                        name="endTime"
                        value={day.sessions[sessionKey].endTime}
                        onChange={(event) =>
                          handleSessionChange(
                            dayIndex,
                            sessionIndex,
                            "endTime",
                            event
                          )
                        }
                        required
                        style={{
                          borderRadius: "6px",
                          padding: "8px",
                        }}
                      />
                    </Col>

                    <Col md={2} className="text-end">
                      <Button
                        variant="danger"
                        onClick={() =>
                          handleRemoveSession(dayIndex, sessionIndex)
                        }
                        style={{
                          backgroundColor: "#ff0000",
                          border: "none",
                          color: "#fff",
                          marginLeft: "10px",
                          borderRadius: "6px",
                          padding: "8px 16px",
                        }}
                      >
                        Remove
                      </Button>
                    </Col>
                  </Row>
                ))}
              </div>

              <Button
                onClick={() => handleAddSession(dayIndex)}
                style={{
                  backgroundColor: "#007bff",
                  border: "none",
                  color: "#fff",
                  borderRadius: "6px",
                  padding: "8px 16px",
                }}
              >
                + Add Session
              </Button>

              {batchData.days.length > 1 && (
                <Button
                  variant="danger"
                  onClick={() => handleRemoveRow(dayIndex)}
                  style={{
                    backgroundColor: "#ff0000",
                    border: "none",
                    color: "#fff",
                    marginLeft: "10px",
                    borderRadius: "6px",
                    padding: "8px 16px",
                  }}
                >
                  Remove Day
                </Button>
              )}
            </div>
          ))}

          <Button
            onClick={handleAddRow}
            className="mt-3"
            style={{
              backgroundColor: "#007bff",
              border: "none",
              color: "#fff",
              borderRadius: "6px",
              padding: "9px 22px",
              marginLeft: '3%'
            }}
          >
            + Add Day
          </Button>

          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "-44px",
              gap: "10px",
            }}
          >
            <Button
              type="submit"
              style={{
                backgroundColor: "green",
                padding: "8px 16px",
                border: "none",
                color: "#fff",
                fontSize: "14px",
                borderRadius: "6px",
              }}
            >
              Submit
            </Button>
            <Button
              type="button"
              onClick={handleCancel}
              style={{
                backgroundColor: "red",
                padding: "8px 16px",
                border: "none",
                color: "#fff",
                fontSize: "14px",
                borderRadius: "6px",
              }}
            >
              Close
            </Button>
          </div>
        </div>

      </form>
      {showConfirmation && (
        <Modal show={showConfirmation} onHide={closeConfirmation} centered>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure you want to remove this day?</Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={closeConfirmation}
              style={{ backgroundColor: "grey" }}
            >
              Cancel
            </Button>
            <Button
              variant="danger"
              onClick={confirmRemoveDay}
              style={{ backgroundColor: "green" }}
            >
              Remove
            </Button>
          </Modal.Footer>
        </Modal>
      )}
      <Modal
        show={showCancelConfirmationModal}
        onHide={handleCancelCancel}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>Are you sure you want to cancel?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" style={{
            backgroundColor: "red",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            borderRadius: "6px",
            padding: "8px 16px",
          }} onClick={handleCancelCancel}>
            No
          </Button>
          <Button variant="danger" style={{
            backgroundColor: "green",
            border: "none",
            color: "#fff",
            marginLeft: "10px",
            borderRadius: "6px",
            padding: "8px 16px",
          }} onClick={handleConfirmCancel}>
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
      <ToastContainer position="bottom-right" />
    </div>
  );
};

const New = ({ onFormSubmit }) => {
  return (
    <div>
      <BatchForm onFormSubmit={onFormSubmit} />
    </div>
  );
};

export default New;
